import styled from 'styled-components';
import withComponent from '@/hoc/withComponent';
import React, {useEffect, useRef} from 'react';
import FlexStyled from '@/styled/FlexStyled';
import LogoComponent from "@/components/Logo"
import User from '@/components/user/index';


const Container = styled.div`
`;


export default withComponent((props) => {
    return (
        <Container>
            <FlexStyled $flexShrink={0} $justifyContent='center' style={{}}>
                <FlexStyled $justifyContent='space-between' $alignItems='center'
                            style={{width: '100%', height: 60, padding: '0 50px', position: 'relative'}}>
                    <div>
                        <LogoComponent isDark={false}/>
                    </div>
                    <FlexStyled $alignItems='center'>
                        <User/>
                    </FlexStyled>
                </FlexStyled>
            </FlexStyled>
        </Container>
    );
});

